import { DashboardFilters } from 'utils/types/dashboardFilters';

export interface DashboardFiltersEntity {
  id: string;
  appliedFilters: DashboardFilters;
}

export const DASHBOARD_FILTER_KEY_MAP: Record<keyof DashboardFilters, string> =
  {
    startDate: 'filter[start-date]',
    endDate: 'filter[end-date]',
    learningTeams: 'filter[learning-team-id]',
  };
